import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import DemoImage from './DemoImage';
import GalleryImage from './GalleryImage/GalleryImage';
import GalleryLarge from './GalleryLarge';
import GalleryMedium from './GalleryMedium';
import GallerySmall from './GallerySmall';


export default class UploadResult extends Component {
  static propTypes = {
    currentImage: PropTypes.object,
    applicationMode: PropTypes.string
  };

  render() {
    let content;
    if (this.props.currentImage.public_id) {
      let applicationMode = this.props.applicationMode;
      let dpr = window.devicePixelRatio || 2;
      let thumbSrc = 'images/ico-thumb' + (dpr > 1.0 ? '@2x' : '') + '.png';
      let details = this.props.currentImage.original_filename + '.' + this.props.currentImage.format.toLowerCase() + ' (' + this.props.currentImage.width + 'x' + this.props.currentImage.height + ' ' +
        this.props.currentImage.format.toUpperCase() + ', ' + Math.round(this.props.currentImage.bytes / 1024) + ' KB)';
      let publicId = this.props.currentImage.public_id;
      content = (
        <section className="panel-demo-result">
          <header className="container heading">
            <div className="center ed">
              <div className="ico pull-left">
                <img src={thumbSrc} height="59" width="75" />
              </div>
              <h2><span>Image manipulations for: </span> {details}</h2>
            </div>
          </header>
          <div className="gallery" style={{ zIndex: 1 }}>
            <MediaQuery query="(min-width: 1200px)">
              <GalleryLarge showDetails={this.props.actions.showDetails} publicId={publicId} applicationMode={applicationMode}/>
            </MediaQuery>
            <MediaQuery query="(max-width:1199px) AND (min-width: 992px)">
              <GalleryMedium showDetails={this.props.actions.showDetails} publicId={publicId} applicationMode={applicationMode}/>
            </MediaQuery>
            <MediaQuery query="(max-width: 991px)">
              <GallerySmall showDetails={this.props.actions.showDetails} publicId={publicId} applicationMode={applicationMode}/>
            </MediaQuery>
          </div>
        </section>);
    } else {
      content = null;
    }
    return (
      <div>
        {content}
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** ./src/js/components/UploadResult.js
 **/